import { useMutation, useQueryClient } from "react-query";

import { crearPersona, updatePersona, deletePersona} from '../../services/Personas';

import { toast } from 'react-hot-toast';
const queryKey = "Personas";

export const usePersonasMutations = () => {
  const queryClient = useQueryClient();
  const onError = (err = null) => {
    if (err.statusCode === 409) {
      return toast.error(`El valor ${err.duplicateValue} ya se encuentra registrado`);
    }
    toast.error('Error consulte con Soporte!');
  };

  const onSuccess = () => {
    toast.success('Datos Guardados Exitosamente!');
    queryClient.invalidateQueries(queryKey);
  };

  const addPersona = useMutation((body) => crearPersona(body), {
    onSuccess,
    onError: (err) => onError(err),
  });

  const updatePersonaC = useMutation((body) => updatePersona(body), {
    onSuccess,
    onError: (err) => onError(err),
  });

  const removePersona = useMutation((id) => deletePersona( id), {
    onSuccess,
    onError,
  });

  return { addPersona, updatePersonaC, removePersona };
};
export default usePersonasMutations;